$('#password_reset_show').on('click', function(e){
    e.preventDefault();
    $('.back_to_login').removeClass('active');
    $('#password_reset_show').addClass('active').attr('disabled', 'disabled');
});

$('.back_to_login').on('click', function(e){
    e.preventDefault();
    $('#password_reset_show').removeClass('active');
    $('.back_to_login').addClass('active').attr('disabled', 'disabled');
});